module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "resumePreview"
    }
  }, [(_vm.resume.profile && _vm.resume.profile.name) ? _c('section', {
    attrs: {
      "data-name": "profile"
    }
  }, [_c('h1', [_vm._v("\n        " + _vm._s(_vm.resume.profile.name) + "\n    ")]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.resume.profile.title))]), _vm._v(" "), _c('p', [_c('small', [_vm._v(_vm._s(_vm.resume.profile.city))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.resume.profile.birthday))])])]) : _vm._e(), _vm._v(" "), (_vm.resume.projects && _vm.resume.projects.length > 0) ? _c('section', {
    attrs: {
      "data-name": "projects"
    }
  }, [_c('h2', [_vm._v("项目经历")]), _vm._v(" "), _c('ol', _vm._l((_vm.resume.projects), function(item) {
    return _c('li', [_c('h3', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.details),
        expression: "item.details"
      }]
    }, [_vm._v(_vm._s(item.details))])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.resume.workHistory && _vm.resume.workHistory.length > 0) ? _c('section', {
    attrs: {
      "data-name": "workHistory"
    }
  }, [_c('h2', [_vm._v("工作经历")]), _vm._v(" "), _c('ol', _vm._l((_vm.resume.workHistory), function(item) {
    return _c('li', [_c('h3', [_vm._v(_vm._s(item.company))]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.details),
        expression: "item.details"
      }]
    }, [_vm._v(" " + _vm._s(item.details) + " ")])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.resume.education && _vm.resume.education.length > 0) ? _c('section', {
    attrs: {
      "data-name": "education"
    }
  }, [_c('h2', [_vm._v("毕业院校")]), _vm._v(" "), _c('ol', _vm._l((_vm.resume.education), function(item) {
    return _c('li', [_c('h3', [_vm._v(_vm._s(item.school) + "\n            "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.details),
        expression: "item.details"
      }]
    }, [_vm._v(" - " + _vm._s(item.details) + " ")])])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.resume.awards && _vm.resume.awards.length > 0) ? _c('section', {
    attrs: {
      "data-name": "awards"
    }
  }, [_c('h2', [_vm._v("获奖情况")]), _vm._v(" "), _c('ol', _vm._l((_vm.resume.awards), function(item) {
    return _c('li', [_c('h3', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.details),
        expression: "item.details"
      }]
    }, [_vm._v(_vm._s(item.details))])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.resume.contacts && _vm.resume.contacts.length > 0) ? _c('section', {
    attrs: {
      "data-name": "contacts"
    }
  }, [_c('h2', [_vm._v("联系方式")]), _vm._v(" "), _c('table', _vm._l((_vm.resume.contacts), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.contact))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.content),
        expression: "item.content"
      }]
    }, [_vm._v(_vm._s(item.content))])])
  }))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-0452b645"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResumePreview.vue
// module id = 74
// module chunks = 1